// eslint-disable-next-line
import axios, { isAxiosError } from "axios";
import Cookies from "js-cookie";

axios.defaults.baseURL = "https://thecharmingtreasure.in/api/billing/";
axios.defaults.headers.common["Authorization"] = Cookies.get("auth-token");
export default axios;
